import { STORE_IMMUTABLE_SUBMENU } from "../actions";

export default function immutableMenuList(state = {}, action) {
  switch (action.type) {
    case STORE_IMMUTABLE_SUBMENU:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/immutableSubMenu.js